import { Route, Routes } from "react-router-dom";
import App from "../App";
import LandingPage from "../pages/landing/LandingPage";
import KarbonAyakIzi from "../pages/hesaplama/KarbonAyakIzi";
import Grafik from "../pages/analiz/Grafik";
import Egitim from "../pages/egitim/Egitim";
import Raporlama from "../pages/raporlama/Raporlama";
import IsSurekliligi from "../pages/issurekliligi/IsSurekliligi";
import NotFoundPage from "../pages/not-found/NotFound";
import OsbukBulten from "../pages/bulten/OsbukBulten";
import BaskanMesaj from "../pages/landing/BaskanMesaj";
import ForumEkle from "../pages/forum/ForumEkle";
import ForumAyrinti from "../pages/forum/ForumAyrinti";
import StratejikPlanCalismasi from "../pages/stratejik-plan-çalismasi/StratejikPlanCalismasi";
import AdminBelgeler from "../pages/admin-page/AdminBelgeler";
import MassEmail from "../pages/admin/MassEmail";
import SurveyResults from "../pages/admin/SurveyResults";
// import { HasPermission } from "../utils/auth";
// import { Permission } from "../services/auth/permissions";
// import NotFoundPage from "../pages/not-found/NotFound";
// import AccessDeniedPage from "../pages/access-denied/AccessDeniedPage";
import ChangeEmailPage from "../pages/auth/ChangeEmail";
// import ChangePasswordPage from "../pages/auth/ChangePassword";
import ProfilePage from "../pages/auth/Profile";
import LoginSebis from "../pages/login/LoginSebis";
import RegisterSebis from "../pages/register/RegisterSebis";
import { HasPermission, useAuth, PublicPageWrapper } from "../utils/auth";
import { Role } from "../services/auth/auth.dto";
import AccessDeniedPage from "../pages/access-denied/AccessDeniedPage";
import Homepage from "../pages/homepage/Homepage";
import SoruCevapSayfası from "../pages/yapaz-zeka/SoruCevapSayfası";
import UsersPage from "../pages/users/UsersPage";
import ForumHomePage from "../pages/forum/ForumHomePage";
import ForumlarPage from "../pages/forum/ForumlarPage";
import ChangePasswordPage from "../pages/auth/ChangePassword";
import ResetPassword from "../pages/auth/ResetPassword";
import ForgotPassword from "../pages/auth/ForgotPassword";
import PageEdit from "../pages/admin/PageEdit";
import StratejikAnket from "../pages/anketler/StratejikAnket";
import CevreselGostergelerAnket from "../pages/anketler/CevreselGostergelerAnket";
import StratejikRapor from "../pages/raporlar/StratejikRapor";
import CevreselGostergelerRapor from "../pages/raporlar/CevreselGostergelerRapor";
// import RolePage from "../pages/role/Role";

const AppRouter = () => {
  const auth = useAuth();

  const userRole = auth.getUser().role;
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      {/* <Route path="/2" element={<LandingPage2 />} /> */}
      <Route path="/loginsebis" element={<LoginSebis />} />
      {/* <Route path="/loginosbuk" element={<LoginOsbuk />} /> */}
      <Route path="/register" element={<RegisterSebis />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/password_reset/confirm/:uid/:token" element={<ResetPassword />} />
      <Route path="/app" element={<App />}>
        <Route path="profile" element={<ProfilePage />} />
        <Route
          path="profile"
          element={
            <HasPermission role={Role.USER}>
              <ProfilePage />
            </HasPermission>
          }
        />
        <Route
          path="change-email"
          element={
            <HasPermission role={Role.USER}>
              <ChangeEmailPage />
            </HasPermission>
          }
        />
        <Route
          path="change-password"
          element={
            <HasPermission role={Role.USER}>
              <ChangePasswordPage />
            </HasPermission>
          }
        />
        <Route
          path="homepage"
          element={
            <HasPermission role={Role.USER}>
              <Homepage />
            </HasPermission>
          }
        />
        <Route
          path="karbonayakizi"
          element={
            <PublicPageWrapper>
              <KarbonAyakIzi />
            </PublicPageWrapper>
          }
        />
        <Route
          path="rapor"
          element={
            <PublicPageWrapper>
              <Raporlama />
            </PublicPageWrapper>
          }
        />
        <Route
          path="grafik"
          element={
            <PublicPageWrapper>
              <Grafik />
            </PublicPageWrapper>
          }
        />
        <Route
          path="egitim"
          element={
            <PublicPageWrapper>
              <Egitim />
            </PublicPageWrapper>
          }
        />
        <Route
          path="is-surekliligi"
          element={
            <PublicPageWrapper>
              <IsSurekliligi />
            </PublicPageWrapper>
          }
        />
        <Route
          path="bulten"
          element={
            <PublicPageWrapper>
              <OsbukBulten />
            </PublicPageWrapper>
          }
        />
        <Route
          path="baskan-mesaj"
          element={
            <PublicPageWrapper>
              <BaskanMesaj />
            </PublicPageWrapper>
          }
        />
        <Route
          path="stratejik-plan"
          element={
            <HasPermission role={Role.USER}>
              <StratejikPlanCalismasi />
            </HasPermission>
          }
        />
        <Route
          path="stratejik-anket"
          element={
            <PublicPageWrapper requireLoginForAction={true} actionMessage="Anket doldurmak için giriş yapmalısınız.">
              <StratejikAnket />
            </PublicPageWrapper>
          }
        />
        <Route
          path="cevresel-gostergeler-anket"
          element={
            <PublicPageWrapper requireLoginForAction={true} actionMessage="Anket doldurmak için giriş yapmalısınız.">
              <CevreselGostergelerAnket />
            </PublicPageWrapper>
          }
        />

        <Route
          path="forum-homepage"
          element={
            <HasPermission role={Role.OSBUK_USER}>
              <ForumHomePage />
            </HasPermission>
          }
        />
        <Route
          path="forum-page/:topicId"
          element={
            <HasPermission role={Role.OSBUK_USER}>
              <ForumlarPage />
            </HasPermission>
          }
        />
        <Route
          path="forum-ekle"
          element={
            <HasPermission role={Role.OSBUK_USER}>
              <ForumEkle />
            </HasPermission>
          }
        />
        <Route
          path="forum-ayrinti/:idForum/:topicId"
          element={
            <HasPermission role={Role.OSBUK_USER}>
              <ForumAyrinti />
            </HasPermission>
          }
        />

        <Route
          path="yapay-zeka"
          element={
            <HasPermission role={Role.OSBUK_USER}>
              <SoruCevapSayfası />
            </HasPermission>
          }
        />
      </Route>

      <Route path="/admin" element={<App />}>
        <Route
          path="belgeler"
          element={
            <HasPermission role={Role.ADMIN}>
              <AdminBelgeler />
            </HasPermission>
          }
        />
        <Route
          path="users"
          element={
            <HasPermission role={Role.ADMIN}>
              <UsersPage />
            </HasPermission>
          }
        />
        <Route
          path="send-mass-email"
          element={
            <HasPermission role={Role.ADMIN}>
              <MassEmail />
            </HasPermission>
          }
        />
        <Route
          path="survey-results"
          element={
            <HasPermission role={Role.ADMIN}>
              <SurveyResults />
            </HasPermission>
          }
        />
        <Route
          path="page-edit"
          element={
            <HasPermission role={Role.ADMIN}>
              <PageEdit />
            </HasPermission>
          }
        />
        <Route
          path="stratejik-rapor"
          element={
            <HasPermission role={Role.ADMIN}>
              <StratejikRapor />
            </HasPermission>
          }
        />
        <Route
          path="cevresel-gostergeler-rapor"
          element={
            <HasPermission role={Role.ADMIN}>
              <CevreselGostergelerRapor />
            </HasPermission>
          }
        />
      </Route>

      <Route path="/access-denied" element={<AccessDeniedPage />} />
      <Route path="/not-found" element={<NotFoundPage />} />

      {/* <Route path="/email-confirm" element={<EmailConfirmPage user={auth.getUser()} />} /> */}

      {/* <Route path="/reset-password" element={<ResetPassword email={""} />} />
      <Route path="/change-email-confirm" element={<NewEmailConfirmPage />} /> */}

      {/*<Route path="/app" element={<App />}>
        <Route
          path="roles"
          element={
            <HasPermission permissions={[Permission.RoleDefault]}>
              <RolePage />
            </HasPermission>
          }
        />
      </Route>*/}
    </Routes>
  );
};

export default AppRouter;
